import { Form, Input } from "antd";
import React from "react";

const ReusableForm = ({ inputData }) => {
  const [form] = Form.useForm();

  return (
    <div className="add_form_container_box">
      <Form
        layout="vertical"
        initialValues={{
          remember: true,
        }}
        form={form}
      >
        {inputData?.map((item, index) =>
          item.type === "text" ? (
            <Form.Item
              key={index}
              label={item.label}
              name={item.name}
              type={item.type}
              rules={[
                {
                  required: true,
                  message: `Please enter your ${item.label.toLowerCase()}!`,
                },
              ]}
              className="form_input_label"
            >
              <Input value={item.value} className="" />
            </Form.Item>
          ) : item.type === "email" ? (
            <Form.Item
              key={index}
              label={item.label}
              name={item.name}
              type={item.type}
              rules={[
                {
                  required: true,
                  type: item.type,
                  message: `Please enter your email!`,
                },
              ]}
              className="form_input_label"
            >
              <Input value={item.value} className="" />
            </Form.Item>
          ) : (
            <></>
          )
        )}
      </Form>
    </div>
  );
};

export default ReusableForm;
